import { logger } from './logger';

const BASE_URL = import.meta.env.VITE_NCB_BASE_URL || 'https://openapi.nocodebackend.com';
const INSTANCE_ID = import.meta.env.VITE_NCB_INSTANCE_ID || '53830_github_cloudflare_pages';
const API_KEY = import.meta.env.VITE_NCB_API_KEY;

const ncbClient = {
  async request(method, path, body = null, queryParams = {}) {
    const url = new URL(`${BASE_URL}${path}`);
    url.searchParams.set('Instance', INSTANCE_ID);
    
    // Add additional query parameters
    Object.entries(queryParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    const headers = {
      'Content-Type': 'application/json'
    };

    if (API_KEY) {
      headers['Authorization'] = `Bearer ${API_KEY}`;
    }

    const requestData = {
      headers: { ...headers, Authorization: API_KEY ? 'Bearer [REDACTED]' : undefined },
      body: body ? JSON.stringify(body) : null
    };

    const logEntry = logger.logRequest('ncb', method, url.toString(), requestData);
    const startTime = performance.now();

    try {
      const fetchOptions = {
        method,
        headers
      };

      if ((method === 'POST' || method === 'PUT') && body) {
        fetchOptions.body = JSON.stringify(body);
      }

      const response = await fetch(url.toString(), fetchOptions);
      const duration = Math.round(performance.now() - startTime);
      
      const contentType = response.headers.get('content-type') || '';
      let responseData;
      
      if (contentType.includes('application/json')) {
        responseData = await response.json();
      } else {
        responseData = await response.text();
      }

      logger.logResponse(logEntry.id, response.status, responseData, duration, {
        'content-type': contentType,
        status: response.status,
        statusText: response.statusText
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return responseData;
    } catch (error) {
      const duration = Math.round(performance.now() - startTime);
      logger.logError(logEntry.id, error, 0);
      throw error;
    }
  },

  // Convenience methods
  createUser(userData) {
    return this.request('POST', '/create/users', userData);
  },

  getUsers(queryParams = {}) {
    return this.request('GET', '/read/users', null, queryParams);
  },

  getUserById(id) {
    return this.request('GET', `/read/users/${id}`);
  },

  searchUsers(criteria) {
    return this.request('POST', '/search/users', criteria);
  },

  updateUser(id, userData) {
    return this.request('PUT', `/update/users/${id}`, userData);
  },

  deleteUser(id) {
    return this.request('DELETE', `/delete/users/${id}`);
  },

  getSampleRequests() {
    return {
      create: { username: 'sampleuser', password: 'samplepass123' },
      search: { username: 'searchuser', password: 'searchpass123' },
      update: { username: 'updateduser', password: 'newpass123' }
    };
  }
};

export { ncbClient };